import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { WishlistApi } from '../api';
import { useAuth } from '../context/AuthContext';
import { useWishlist } from '../context/WishlistContext';
import { useLocation } from '../context/LocationContext';
import { PageHero, ProductGrid } from '../components/Common';

export default function WishlistPage() {
  const { isLoggedIn, booting } = useAuth();
  const { ids } = useWishlist();
  const { location } = useLocation();
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!isLoggedIn) { setItems([]); return; }
    WishlistApi.list({ pincode: location?.pincode })
      .then((d) => setItems(d.items || []))
      .catch(() => setItems([]));
    // Re-fetch when the wishlist changes or the delivery location moves.
  }, [isLoggedIn, ids.length, location?.pincode]);

  if (booting) return <><PageHero title="My Wishlist" /><section><div className="container"><p className="muted">Loading…</p></div></section></>;

  if (!isLoggedIn) {
    return (
      <>
        <PageHero title="My Wishlist" />
        <section>
          <div className="container empty-state">
            <i className="fas fa-heart" />
            <h3>Login to see your wishlist</h3>
            <p className="muted">Save your favourite products and find them here.</p>
            <Link className="btn-gold" to="/login">Login / Sign Up</Link>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <PageHero title="My Wishlist" />
      <section>
        <div className="container">
          {items === null ? (
            <p className="muted">Loading your wishlist…</p>
          ) : items.length ? (
            <ProductGrid products={items.map((w) => w.product || w).filter(Boolean)} />
          ) : (
            <div className="empty-state">
              <i className="far fa-heart" />
              <h3>Your wishlist is empty</h3>
              <p className="muted">Tap the heart on any product to save it here.</p>
              <Link className="btn-gold" to="/">Browse Products</Link>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
